import type { RendererProps } from './type';

import { CaretDownIcon, ChartLineIcon, OrderIcon } from '@shopify/polaris-icons';
import { ActionList, Icon, InlineStack, Popover, Text } from '@shopify/polaris';
import { useLocationHandlers } from '~/hooks/useLocationHandlers';
import { ModalType, useGModalContext } from '~/presentation/ui';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';

export const OrderIdCell = ({ value }: Pick<RendererProps<string>, 'value'>) => {
  const { t } = useTranslation();

  const [active, setActive] = useState(false);

  const { onOpenModal } = useGModalContext<ModalType.ORDER_JOURNEY>();
  const { handleOpenPageShopifyInNewTab } = useLocationHandlers();

  const handleViewOrderJourney = () => {
    onOpenModal(ModalType.ORDER_JOURNEY, { id: value, orderId: value });
  };

  const handleViewOrderDetails = () => {
    handleOpenPageShopifyInNewTab(`orders/${value}`);
  };

  const toggleActive = useCallback(() => setActive((active) => !active), []);

  return (
    <Popover
      active={active}
      activator={
        <div
          className="GReportTable__CellContent--clickable flex items-center pl-3 w-full h-full rounded-md cursor-pointer"
          onClick={toggleActive}
        >
          <InlineStack gap="200" blockAlign="center" wrap={false}>
            <Text as="span" variant="bodyMd" tone="subdued">
              {value}
            </Text>

            <span className="opacity-0 group-hover/GReportTable__Row:opacity-100">
              <Icon source={CaretDownIcon} />
            </span>
          </InlineStack>
        </div>
      }
      onClose={toggleActive}
    >
      <ActionList
        actionRole="menuitem"
        items={[
          {
            id: 'view_order_journey',
            content: t('View order journey'),
            icon: ChartLineIcon,
            onAction: handleViewOrderJourney,
          },
          {
            id: 'view_order_details',
            content: t('View order details on Shopify'),
            icon: OrderIcon,
            onAction: handleViewOrderDetails,
          },
        ]}
      />
    </Popover>
  );
};
